module.exports = __webpack_public_path__ + "img/opendoor2.af979b49.png";